import get from 'lodash/get';
import { bool, func, node, oneOf, string } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import './shine-button.m.css';

const ShineButton = ({
  size,
  rounded,
  variant,
  label,
  children,
  icon,
  className,
  features,
  discountedAmnt,
  isShine,
  ...props
}) => {
  const independenceSale = features?.independence_day?.active;
  const labelClass = independenceSale ? 'label' : '';
  const animation = !isShine ? 'animation' : '';
  return (
    <button
      type="button"
      styleName={`btn shine btn-${size} btn-rounded-${rounded} btn-${variant} ${animation}`}
      className={`${className}`}
      {...props}
    >
      {icon === 'left' && children}
      <span className={labelClass}>{label}</span>
      {icon === 'right' && children}
    </button>
  );
};

ShineButton.propTypes = {
  size: oneOf(['small', 'medium', 'large']),
  rounded: oneOf(['default', 'full', 'half']),
  label: string,
  onClick: func,
  children: node,
  icon: string,
  styleName: string,
  className: string,
  variant: string,
  isShine: bool,
};

ShineButton.defaultProps = {
  size: 'medium',
  rounded: 'default',
  onClick: undefined,
  children: null,
  icon: 'right',
  variant: 'primary',
  isShine: true,
};

const mapStateToProps = (state) => ({
  features: get(state, ['qt', 'config', 'features'], {}),
});

export default connect(mapStateToProps)(ShineButton);
